<template>
  <div class="w-full h-full bg-white flex flex-col px-8 overflow-y-auto">
    <div class="py-8">
      <h2 class="font-semibold">Vector Collections</h2>
      <!-- PRO-635: read-only. The registry is derived state, not configuration: the indexer
           provisions an organization's own collection and elects its filterable fields from the
           cardinality it observes while streaming the feed. Editing it here could only disagree with
           the cluster — renaming a row pointed indexing at a new, empty collection and stranded the
           old one's points, and deleting a row was undone by the next indexing run. A one-off index
           is added in Qdrant directly. -->
      <p class="text-gray text-sm mt-1">
        Managed by the indexer — provisioned per organization, with filterable fields elected from
        each feed. Read-only here.
      </p>
    </div>

    <!-- vector geometry is SSOT-locked (must match what each collection was ingested with) -->
    <div class="flex gap-10 text-gray-dark mb-6">
      <div class="flex flex-col gap-1">
        <label class="font-bold">Vector size (locked)</label>
        <span>{{ vectorSize || '—' }}</span>
      </div>
      <div class="flex flex-col gap-1">
        <label class="font-bold">Distance (locked)</label>
        <span>{{ distance || '—' }}</span>
      </div>
    </div>

    <table class="w-full text-sm mb-8">
      <thead>
        <tr class="text-left text-gray-dark border-solid border-0 border-b border-gray-border">
          <th class="py-2">Name</th>
          <th class="py-2">Source type</th>
          <th class="py-2">Assignment</th>
          <th class="py-2">Indexed fields</th>
          <th class="py-2">Quantized</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="c in collections" :key="c.id" class="border-solid border-0 border-b border-gray-border">
          <td class="py-2 font-mono">{{ c.name }}</td>
          <td class="py-2">{{ c.source_type }}</td>
          <td class="py-2">{{ c.organization_id || 'Shared (all orgs)' }}</td>
          <td class="py-2">{{ (c.payload_indexes || []).map(p => p.field).join(', ') || '—' }}</td>
          <td class="py-2">{{ c.quantization ? 'yes' : 'default' }}</td>
        </tr>
        <tr v-if="!collections.length">
          <td class="py-4 text-gray" colspan="5">No collections registered yet.</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import vectorCollectionService from '@/services/amio/vector-collection.service'
import toaster from '@/utils/toaster'

export default {
  name: 'AdminVectorCollections',

  data() {
    return {
      collections: [],
      vectorSize: null,
      distance: null
    }
  },

  methods: {
    async loadData() {
      const [collections, schema] = await Promise.all([
        vectorCollectionService.list(),
        vectorCollectionService.getIndexSchema()
      ])
      this.collections = collections
      this.vectorSize = schema.vector_size
      this.distance = schema.distance
    }
  },

  async mounted() {
    try {
      await this.loadData()
    } catch (err) {
      toaster.error(err.message || err)
    }
  }
}
</script>
